import React from "react";
import { useQuery } from "react-query";
import { getMerchantNotificationAfterRenderJSON } from "./gateway";
import { useNavigate } from "react-router-dom";

function useGetMerchantNotification({
  merchantReference,
  enabled,
  setEnableHandleContinue,
  setEnableMerchantRef,
}: {
  merchantReference: string;
  enabled: boolean;
  setEnableHandleContinue: React.Dispatch<React.SetStateAction<boolean>>;
  setEnableMerchantRef: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return useQuery({
    queryFn: () => getMerchantNotificationAfterRenderJSON(merchantReference),
    queryKey: ["getMerchantNotificationAfterRenderJSON", merchantReference],
    enabled,
    refetchInterval: 2000,
    retry: true,
    onSuccess: (data) => {
      if (data?.data?.threeDSCompInd == "Y") {
        setEnableHandleContinue(true);
        setEnableMerchantRef(false);
      }
    },
  });
}

export default useGetMerchantNotification;
